module.exports = __webpack_public_path__ + "media/images/pc/specials/common/store_omiya-96d7deb0d7a3a211705278c445f5bd47.jpg";